import { makeStyles } from "@material-ui/core";
export const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    // width: "auto",
    padding: "2rem 11.25rem",
    justifyContent: "center",
    gap: "2rem",
    backgroundColor: "#F4F3F3",
    [theme.breakpoints.down(1240)]: {
      flexDirection: "column",
      display: "flex",
      alignItems: "center",
      padding: "2rem 0",
    },
  },
  firstSection: {
    display: "flex",
    flexDirection: "column",
    width: "30rem",
    [theme.breakpoints.down(1240)]: {
      borderRadius: "1.875rem",
      boxShadow: " 0.25rem 0.25rem 1.25rem 0.125rem rgba(0,0,0,0.2)",
      backgroundColor: "#ffffff",
      padding: "2.375rem 3.75rem",
      width: "auto",
      marginTop: "-5rem",
    },
    [theme.breakpoints.down(390)]: {
      padding: "2.375rem 1.875rem",
    },
    [theme.breakpoints.down(270)]: {
      padding: "2.375rem 0.1rem",
    },
    "& .formBox": {
      height: "30.0625rem",
      margin: "3rem auto",
      padding: "2.375rem 6.75rem 2.125rem 3.1875rem",
      borderRadius: "1.875rem",
      boxShadow: " 0.25rem 0.25rem 1.25rem 0.125rem rgba(0,0,0,0.2)",
      backgroundColor: "#ffffff",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      alignItems: "stretch",
      [theme.breakpoints.down(1240)]: {
        order: 2,
        borderRadius: "0",
        boxShadow: "none",
        backgroundColor: "#ffffff",
        padding: "0",
        margin: 0,
      },
      "& .formItem": {
        margin: "1rem 0",
        "& .name": {
          fontFamily: "Montserrat",
          fontSize: 20,
          fontWeight: "bold",
          lineHeight: 2.2,
          textAlign: "left",
          color: theme.palette.text.primary,
        },
        "& .nameDisabled": {
          opacity: 0.6,
        },
        "& .selectorContainer": {
          "& >div": { width: "15.625rem" },
        },
        "& .beforeSlider": {
          marginTop: "2.5rem",
        },
      },
    },
  },
  secondSection: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "38.0063rem",
    marginLeft: "6.25rem",
    [theme.breakpoints.down(1240)]: {
      width: "auto",
      margin: "2rem 0",
      alignItems: "center",
    },
    "& .imageContainer": {
      // width: "38.0063rem",
      // height: "22.75rem",
      [theme.breakpoints.down(1240)]: {
        width: "21.0625rem",
        height: "10.625rem",
      },
    },
    "& .buttonContainer": {
      textAlign: "right",
      [theme.breakpoints.down(1240)]: {
        marginTop: "4rem",
        textAlign: "center",
        padding: 0,
      },
      "& .buttonC": {
        background: "#00a9c2",
      },
    },
    "& .textContainer": {
      marginTop: "2.625rem",
      marginBottom: "7rem",
    },
  },
  text: {
    fontFamily: "Montserrat",
    fontSize: 16,
    lineHeight: 1.88,
    textAlign: "left",
    [theme.breakpoints.down(1240)]: {
      fontSize: 12,
      lineHeight: 1.67,
    },
    color: theme.palette.text.secondary,
    "& .style1": {
      fontWeight: "bold",
    },
  },
}));
